<template>
  <div class="transfer-item">
    <van-row class="title">
      <van-col :span="16">
        <span>{{ item.order_num }}</span>
      </van-col>
      <van-col :span="8" class="txt-right">
        <span
          v-if="item.status != 1"
          :class="item.status == 3 ? 'data-down' : 'data-up'"
          >{{ item.status == 2 ? this.$t('common.finished'): this.$t('common.canceled') }}</span
        >
        <span v-else @click="toCancel(item.id)" class="link-btn">{{ $t('common.cancel') }}</span>
      </van-col>
    </van-row>
    <van-row class="body">
      <van-col :span="24" class="data-up"
        >{{ $t("transfer.stime") }} : {{ item.addtime }}</van-col
      >
      <van-col :span="24" class="data-down"
        >{{ $t("transfer.etime") }} : {{ item.arrival_time }}</van-col
      >
    </van-row>
    <van-row class="table">
      <van-col :span="12">
        <p>{{ $t("transfer.receiving") }}</p>
        <span>{{ item.to_username }}</span>
      </van-col>
      <van-col :span="12" class="txt-right">
        <p>{{ $t("transfer.type") }}</p>
        <span>{{ item.coin }}</span>
      </van-col>

      <van-col :span="8">
        <p>{{ $t("transfer.num") }}</p>
        <span>{{ item.amount }}</span>
      </van-col>
      <van-col :span="8" class="txt-center">
        <p>{{ $t("withdrawal.fee") }}</p>
        <span>{{ item.sxf == 0 ? "--" : item.sxf }}</span>
      </van-col>
      <van-col :span="8" class="txt-right">
        <p>{{ $t("transfer.arrivalnum") }}</p>
        <span>{{ item.arrival_amount }}</span>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  name: "LstItem",
  props: ["item"],
  computed: {
    safeItem() {
      return this.item || {};
    },
  },
  methods:{
    async toCancel(id){
        await this.$http({
        method: "post",
        url: "cancelInternalTransfer",
        data: {
          id:id
        },
      }).then((res) => {
        this.$toast.success(res.msg)
        this.$emit('reset-lst')
      })
    },
  }
};
</script>

<style>
</style>
